<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kundengruppe erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.customer-groups.store'))">
                <form-fields :form="form" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>